import { CitizenshipStatus, Gender, Suffix } from 'vg-interaction-model';

export type IDPSState = IDPSResponse | RedirectToPVRResponse;
export interface IDPSResponse {
  personalInfo: PersonalInfo;
  contactInfo: ContactInfo;
  veridHash: string;
  intent: string;
  poid: string;
  clearData?: ClearData;
}

interface RedirectToPVRResponse {
  redirectToPVR: true;
}

export interface PersonalInfo {
  firstName: string;
  middleName: string;
  lastName: string;
  emailAddress: string;
  dateOfBirth: string;
  citizenship: CitizenshipStatus;
  countryOfResidence: string;
  tin: string;
  gender: Gender;
  suffix: Suffix;
}
export interface ContactInfo {
  primaryPhoneNumber: PrimaryPhoneNumber;
  isStreetSameAsMailing: boolean;
  mailingAddress: Address;
  streetAddress: Address;
}

export interface ClearData {
  clearOutcome: string;
  uploadedFilename: string;
  poid?: string;
}

export interface PrimaryPhoneNumber {
  number: string;
  isCellPhone: boolean;
}

export interface Address {
  zipCode: string;
  state: string;
  city: string;
  street: string;
}
